import styled from "styled-components";

export const OwnerEditContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const OwnerEditPopup = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 492px;
  border-radius: 13px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px 15px 24px;
  box-sizing: border-box;
`;

export const OwnerEditPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #121212;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */

  > img {
    cursor: pointer;
  }
`;

export const OwnerEditInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 316px;
`;

export const OwnerEditInputItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #000;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  box-sizing: border-box;

  > input {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border-radius: 15px;
    border: 1px solid #b7b7b7;
    outline: none;
    color: var(--Black-500, #202020);
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.24px;
  }
`;

export const OwnerEditButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  > .button {
    flex: 1;
    display: flex;
    padding: 15px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    color: #7f25fb;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.165px;
    cursor: pointer;

    &.confirm {
      background: #7f25fb;
      color: #fff;
    }
  }
`;

export const OwnerEditDomainWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
`;

export const OwnerEditDomainItem = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  color: #000;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14.5px; /* 120.833% */
`;

export const OwnerEditCheckBox = styled.div<{
  selected: boolean;
}>`
  border: 1px solid ${({ selected }) => (selected ? "#7F25FB" : "#d9d9d9")};
  background: ${({ selected }) => (selected ? "#7F25FB" : "#fff")};
  width: 13px;
  height: 13px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  > img {
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    object-fit: contain;
  }
`;
